import styles from './index.module.less';
import Image from 'next/image';
export default function HowReversePhoto({ content }: { content: any }) {
  const showContent = content.contentInfo['section-why1'];
  if (!showContent.title) {
    return null;
  }
  return (
    <section className={styles.sectionWhy1}>
      <div className={styles.innerSpace}>
        {/* Section Header */}
        <div className={styles.header}>
          <h2 className={styles.title}>{showContent.title}</h2>
          <p className={styles.description}>{showContent.desc}</p>
        </div>

        {/* Main Image */}
        {showContent.imgPath && (
          <div className={styles.imageWrapper}>
            <Image
              width={800}
              height={400}
              unoptimized
              src={showContent.imgPath}
              alt={showContent.title}
              className={styles.mainImage}
            />
          </div>
        )}

        {/* Cards Grid Layout */}
        {showContent.cards && showContent.cards.length >= 4 && (
          <div className={styles.cardsGrid}>
            {/* Card 0 */}
            <div className={styles.card0}>
              <div className={styles.cardContent}>
                <div className={styles.iconWrapper}>
                  <Image
                    width={32}
                    height={32}
                    unoptimized
                    src={showContent.cards[0].svg}
                    alt={showContent.cards[0].title}
                    className={styles.icon}
                  />
                </div>
                <h3 className={styles.cardTitle}>{showContent.cards[0].title}</h3>
                <p className={styles.cardDesc}>{showContent.cards[0].desc}</p>
              </div>
              <img src={showContent.cards[0].imgPath || ''} className={styles.cardImage} alt="" />
            </div>

            {/* Card 1 */}
            <div className={styles.card1}>
              <div className={styles.cardContent}>
                <div className={styles.leftContent}>
                  <div className={styles.iconWrapper}>
                    <Image
                      width={48}
                      height={48}
                      src={showContent.cards[1].svg}
                      alt={showContent.cards[1].title}
                      className={styles.icon}
                    />
                  </div>
                  <h3 className={styles.cardTitle}>{showContent.cards[1].title}</h3>
                  <p className={styles.cardDesc}>{showContent.cards[1].desc}</p>
                </div>
                <img src={showContent.cards[1].imgPath || ''} className={styles.cardImage} alt="" />
              </div>
            </div>

            {/* Card 2 */}
            <div className={styles.card2}>
              <div className={styles.cardContent}>
                <div className={styles.iconWrapper}>
                  <Image
                    width={48}
                    height={48}
                    src={showContent.cards[2].svg}
                    alt={showContent.cards[2].title}
                    className={styles.icon}
                  />
                </div>
                <h3 className={styles.cardTitle}>{showContent.cards[2].title}</h3>
                <p className={styles.cardDesc}>{showContent.cards[2].desc}</p>
              </div>
            </div>

            {/* Card 3 */}
            <div className={styles.card3}>
              <div className={styles.cardContent}>
                <div className={styles.iconWrapper}>
                  <Image
                    width={48}
                    height={48}
                    src={showContent.cards[3].svg}
                    alt={showContent.cards[3].title}
                    className={styles.icon}
                  />
                </div>
                <h3 className={styles.cardTitle}>{showContent.cards[3].title}</h3>
                <p className={styles.cardDesc}>{showContent.cards[3].desc}</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
